import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  FormGroup,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button,
  Container,
  Row,
  Col,
  CardText,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import axios from "axios";
import { toast } from "react-toastify";
import {
  AUTH_BASE_URL,
  BASE_LOGIN_REDIRECT_URL,
  API_BASE_URL,
} from "../../constants/api.constants";
import CardGroup from "reactstrap/lib/CardGroup";
import CardTitle from "reactstrap/lib/CardTitle";
import CardSubtitle from "reactstrap/lib/CardSubtitle";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const RegistrationForm = (props) => {
  const { touched, errors, isSubmitting } = props;
  var registrationComplete = localStorage.getItem("aplSupervisorHasRegistered");

  const redirectUrl = () => {
    window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`);
  };

  return (
    <div className="app flex-row align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md="8">
            <Form>
              <CardGroup>
                <Card
                  style={{ cursor: "pointer" }}
                  body
                  className="text-white bg-success py-5 d-md-down-none cursor:pointer"
                >
                  <div onClick={redirectUrl} title={"Tillbaka till loginsidan"}>
                    <img
                      style={{ width: "100%" }}
                      src={"img/LearnWareLoggo.png"}
                      className="img-avatar"
                      alt="LearnWARE logga in"
                    />
                  </div>
                </Card>
                {!isSubmitting && registrationComplete ? (
                  <Card>
                    {" "}
                    <CardHeader>
                      <CardTitle
                        className="h3"
                        style={{ marginBottom: "0.25rem" }}
                      >
                        <FormattedMessage id="RegistrationCompleted" />
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <FormattedMessage id="AplSupervisorRegistrationMessage" />
                      <Row style={{ justifyContent: "center" }}>
                        <img
                          style={{
                            width: "5rem",
                            height: "5rem",
                            marginBottom: "-2rem",
                            zIndex: "2",
                            borderRadius: "0.6rem",
                          }}
                          alt="Sample"
                          src={"img/AppIcon.png"}
                        />
                      </Row>
                      <Card
                        style={{
                          width: "100%",
                        }}
                      >
                        <CardBody>
                          <CardTitle
                            style={{ textAlign: "center" }}
                            className="mt-2"
                            tag="h5"
                          >
                            <FormattedMessage id="APLAppName" />
                          </CardTitle>
                          <CardText style={{ textAlign: "center" }}>
                            <FormattedMessage id="FollowLinkForYourDeviceToGetStarted" />
                            !
                          </CardText>
                          <Row
                            style={{
                              justifyContent: "center",
                              height: "2.5rem",
                            }}
                          >
                            <a href="https://play.google.com/store/apps/details?id=com.aplBy.learnware">
                              <img
                                style={{
                                  marginBottom: "-2rem",
                                  zIndex: "2",
                                  borderRadius: "0.6rem",
                                  height: "2.5rem",
                                }}
                                alt="Link to app in playstore"
                                src={"img/googleplay-img.png"}
                              />
                            </a>
                          </Row>
                          <Row
                            style={{
                              justifyContent: "center",
                              height: "2.5rem",
                            }}
                          >
                            {/*    CHANGE LINK TO CORRECT PLACE! */}
                            <a href="https://apps.apple.com/se/app/apl-by-learnware/id1629042752">
                              <img
                                style={{
                                  marginBottom: "-2rem",
                                  zIndex: "2",
                                  borderRadius: "0.6rem",
                                  height: "2.5rem",
                                }}
                                alt="Link to app in appstore"
                                src={"img/appstore-img.png"}
                              />
                            </a>
                          </Row>
                        </CardBody>
                      </Card>
                    </CardBody>
                  </Card>
                ) : (
                  <Card>
                    <CardHeader>
                      <CardTitle
                        className="h3"
                        style={{ marginBottom: "0.25rem" }}
                      >
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Header" />
                        <i
                          onClick={redirectUrl}
                          title="Tillbaka till loginsidan"
                          style={{ cursor: "pointer" }}
                          className="fa fa-close float-end close"
                        />
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <CardSubtitle>
                        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Body" />
                      </CardSubtitle>
                      <div style={{ marginTop: "25px" }}>
                        <FormGroup>
                          <Label>
                            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Label.Password" />
                          </Label>
                          <Field
                            className={`form-control ${
                              errors.password &&
                              touched.password &&
                              "is-invalid"
                            }`}
                            type="password"
                            name="password"
                            autoComplete="new-password"
                            placeholder="Ange ditt lösenord"
                          />
                          {errors.password && touched.password && (
                            <div className="invalid-feedback">
                              {errors.password}
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label>
                            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Label.RepeatPassword" />
                          </Label>
                          <Field
                            className={`form-control ${
                              errors.repeatpassword &&
                              touched.repeatpassword &&
                              "is-invalid"
                            }`}
                            type="password"
                            name="repeatpassword"
                            autoComplete="new-password"
                            placeholder="Upprepa ditt lösenord"
                          />
                          {errors.repeatpassword && touched.repeatpassword && (
                            <div className="invalid-feedback">
                              {errors.repeatpassword}
                            </div>
                          )}
                        </FormGroup>

                        <Button
                          type="submit"
                          color="success"
                          block
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.ButtonPressed" />
                          ) : (
                            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Button" />
                          )}
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                )}
              </CardGroup>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues({ password, repeatpassword }) {
    // Add information with request
    return {
      password: password || "",
      repeatpassword: repeatpassword || "",
    };
  },
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .required(
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Password" />
      )
      .matches(
        /(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\\"()\\[\]-]{8,25}$/,
        {
          message: (
            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Format" />
          ),
          excludeEmptyString: true,
        }
      )
      .matches(/^.{8,}$/, {
        message: (
          <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Length" />
        ),
      }),
    repeatpassword: Yup.string()
      .oneOf(
        [Yup.ref("password")],
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.Diff" />
      )
      .required(
        <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Required.RepPassword" />
      ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    axios
      .post(`${AUTH_BASE_URL}/token/newuser`, {
        email: props.email,
        password: values.password,
        grant_type: "password",
        usertype: props.role,
        validationtoken: props.validationtoken,
      })
      .then((response) => {
        if (response.data.code === "999") {
          toast.success(
            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Success" />,
            {
              position: "top-right",
              closeOnClick: true,
              pauseOnHover: true,
              autoClose: 3000,
              onClose: () => {
                if (props.role === "AplSupervisor") {
                  localStorage.setItem("aplSupervisorHasRegistered", true);
                  window.location.reload(false);
                } else {
                  window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`);
                }
              },
            }
          );

          axios.post(`${API_BASE_URL}/user/initialpasswordcreated`, {
            userEmail: props.email,
          });
        }

        if (response.data.code === "902") {
          toast.warning(
            <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.Exists" />,
            TOAST_CONFIG
          );
        }
        if (response.data.code === "901") {
          toast.warning(response.data.message, TOAST_CONFIG);
        }
      })
      .catch((err) => {
        setErrors({ password: err.response ? err.response.data : err.message });
      });
    setSubmitting(false);
    resetForm();
  },
})(RegistrationForm);

export default FormikForm;
